var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"company":_vm.model}},[_c('CandidateTable',{attrs:{"company":_vm.model,"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }